import {GetToken, MessageResponse} from '../Domain';
import {ServicesUrl} from '../../Config/UrlRuotes';
import {Action} from 'react-fetching-library';

export const resolveAction : ( jwToken: string ) => Action<MessageResponse> = jwToken => ({
    method: 'GET',
    endpoint: `${ ServicesUrl.action }/${jwToken}`,
    headers: {
        'Authorization-Token': GetToken()
    }
});
